import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { grey } from "@mui/material/colors";

const ErrorCardcomponent = ({ message, sx }) => {

  return (
    <Card>
      <CardContent
        sx={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          border: '1px solid #E6DEB8',
          boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.1)',
          ...sx
        }}
      >
        <ErrorIcon
          fontSize="large"
          style={{ color: grey[400] }}
        />
        <Typography variant="h4" color="primary" p={1}>
          {message}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ErrorCardcomponent;
